import {
  stickyActionCellProps,
  stickyActionColumnStyle,
  stickyActionTdClass,
  stickyActionThClass,
} from "../utils/gridTableUx";

/**
 * Pinned Actions column header for native HTML data grids.
 */
export function StickyActionsTh({
  tone = "white",
  label = "Actions",
  wide = false,
  extraClassName = "",
}) {
  return (
    <th
      scope="col"
      className={stickyActionThClass(tone, extraClassName)}
      style={stickyActionColumnStyle({ wide })}
    >
      <span className="sr-only">{label}</span>
    </th>
  );
}

/**
 * Pinned Actions column cell for native HTML data grids.
 */
export function StickyActionsTd({
  children,
  selected = false,
  archived = false,
  align = "center",
  wide = false,
  extraClassName = "",
}) {
  return (
    <td
      className={stickyActionTdClass({
        selected,
        archived,
        align,
        wide,
        extra: extraClassName,
      })}
      style={stickyActionColumnStyle({ wide })}
      {...stickyActionCellProps}
    >
      {children}
    </td>
  );
}
